import axios from "../helpers/axios";
import { officeOrderFinanceAnalyticsConstants } from "./constants";

export const getOfficeOrderFinanceAnalytics = ({
    officeId,
    orderId,
    month,
} = {}) => {
    return async (dispatch) => {
        try {
            if (!officeId || !orderId) {
                dispatch({
                    type: officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_FAILURE,
                    payload: {
                        error: "Не найден officeId или orderId",
                    },
                });

                return null;
            }

            dispatch({
                type: officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_REQUEST,
            });

            const res = await axios.get(`/officeAnalytics/${officeId}/order/${orderId}/finance`, {
                params: {
                    month,
                },
            });

            if (res.status === 200) {
                dispatch({
                    type: officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_SUCCESS,
                    payload: res.data,
                });

                return res.data;
            }

            dispatch({
                type: officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_FAILURE,
                payload: {
                    error: res?.data?.error || "Ошибка загрузки финансов заказа",
                },
            });

            return null;
        } catch (error) {
            dispatch({
                type: officeOrderFinanceAnalyticsConstants.GET_OFFICE_ORDER_FINANCE_ANALYTICS_FAILURE,
                payload: {
                    error: error?.response?.data?.error || error.message || "Ошибка загрузки финансов заказа",
                },
            });

            return null;
        }
    };
};

export const clearOfficeOrderFinanceAnalytics = () => ({
    type: officeOrderFinanceAnalyticsConstants.CLEAR_OFFICE_ORDER_FINANCE_ANALYTICS,
});